<!--
 * @Descripttion: 
 * @version: 
 * @Author: mrh
 * @Date: 2020-02-21 09:21:41
 * @LastEditors: mrh
 * @LastEditTime: 2021-01-15 09:58:41
-->
<template>
  <div class="content">
    <h5-header v-if="isWX != 0" :header-msg="headerMsg"></h5-header>
    <!-- <div class="cont">
      <img src="../../assets/img/role.png" alt />
    </div> -->
    <div v-html="content" class="cont"></div>
  </div>
</template>

<script>
import { getActivityRuleContent } from "@/api/picker/index.js";
export default {
  data() {
    return {
      isWX: "1",
      headerMsg: {
        url: "/aboutUs",
      },
      content: "",
    };
  },
  mounted() {
    //   this.rule()
    this.isWX = this.GetQueryString("wx");
    this.getContent();
  },

  methods: {
    getContent() {
      getActivityRuleContent({
        type: "5", //关注9和10， type 教程类型。2.选菜师教程，3.城市合伙人教程，4.无码商品教程，5：选菜师协议，6：城市合伙人协议，7.选菜师攻略教程，
        //8社区店长攻略，9爆款活动规则,10拼单活动规则，11：打印说明文档,12 店长协议,13悦买用户协议，14悦卖用户协议
      }).then((res) => {
        // console.log(res);
        let result = res.content.content
          .replace(/&#x3c;/g, "<")
          .replace(/&#x3e;/g, ">")
          .replace(/&#x22;/g, '"');
        // let result2 = result1.replace(/&#x3e;/g,'>')

        this.content = result;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  overflow: hidden;
  width: auto;
  padding: 0 10px;
  header {
    display: flex;
    align-items: center;
    position: fixed;
    top: 0;
    z-index: 2013;
    width: 100%;
    height: 44px;
    background: #fff;
    z-index: 9999;
    i {
      font-size: 26px;
    }
    p {
      font-size: 18px;
      margin-left: 104px;
    }
  }

  .cont {
    height: calc(100% - 50px);
    //   margin-top: 50px;
    overflow-y: auto;
    overflow-x: hidden;
    text-align: left;
    img {
      width: 345px;
      height: auto;
      display: block;
      margin: 15px;
    }
  }
  //   .mt{
  //       height: calc(100% - 50px);
  //       overflow: auto;
  //       margin-top: 0
  //   }
}
</style>
